import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/api/client";
import type { LandingSummary } from "@/lib/types";

type Status = "live" | "pause" | "prep";

function statusOf(s: LandingSummary): Status {
  if (s.is_paused) return "pause";
  if (s.prod_release_id) return "live";
  return "prep";
}
const LABEL: Record<Status, string> = {
  live: "Опубликован",
  pause: "На паузе",
  prep: "Готовится",
};

export function SitesList() {
  const [sites, setSites] = useState<LandingSummary[] | null>(null);
  const [err, setErr] = useState<string | null>(null);
  const nav = useNavigate();

  useEffect(() => {
    api.listLandings().then(setSites).catch((e) => setErr(String(e.message ?? e)));
  }, []);

  return (
    <div className="wrap">
      <h1>Мои сайты</h1>
      <p className="lead">
        Здесь все ваши сайты. Откройте любой, чтобы обновить его или посмотреть, как он выглядит.
      </p>
      {err && <div className="err">{err}</div>}
      {!sites && !err && <div className="muted">Загрузка…</div>}
      {sites && sites.length === 0 && (
        <div className="card" style={{ padding: 28 }}>
          <div className="muted">Пока нет ни одного сайта. Их создаёт IT в разделе «Настройка».</div>
        </div>
      )}
      <div className="sites">
        {sites?.map((s) => {
          const st = statusOf(s);
          return (
            <div className="card site" key={s.id} onClick={() => nav(`/site/${s.id}`)}>
              <div className="info">
                <div className="nm">{s.name}</div>
                <div className="sub">
                  {s.prod_domain}
                  {s.tags.length > 0 && <> · {s.tags.join(", ")}</>}
                </div>
              </div>
              <div className="right">
                <span className={`pill ${st}`}>
                  <span className="pd" />
                  {LABEL[st]}
                </span>
                <div className="acts">
                  <a
                    className="btn sm"
                    href={`https://${s.prod_domain}`}
                    target="_blank"
                    rel="noreferrer"
                    onClick={(e) => e.stopPropagation()}
                  >
                    Посмотреть сайт ↗
                  </a>
                  <button className="btn sm primary" onClick={() => nav(`/site/${s.id}`)}>
                    Открыть
                  </button>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
